import React, { Component } from "react";
import HomeForm from "../HomeForm/HomeForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : LicensesPage
Description : Compoente que alberga el formulario de Licenses definido en el directorio de componentes
Date Autor Modification
================================================================================
29/09/2022 Santiago Coca - Se define el componente
================================================================================ */

class HomePage extends Component {
    render() {
        return (
            <div>
                <HomeForm />
            </div>
        )
    }
}

export default HomePage;